<template>
  <div>
    <md-content class="row" :class="[{ 'hide-warning' : !showSafariWarning }]">
      <div class="col-12 button-fixed">
        <div class="p-3 pb-4 bg-custom text-white">
          <div class="row">
            <div class="col-10">
              <div class="h4 text-danger bold warning-title">
                Safari warning!
              </div>
            </div>
          </div>
          <div class="row row-column">
            <p class="h5 text-white explanation-text safari-text">
              By default, the Safari browser unfortunately restricts our ability
              to collect important data we use to improve your experience on our
              site. We strongly encourage you to consider using Chrome, Firefox
              or Edge instead.
            </p>
            <p class="h5 text-white explanation-text gpdr-text">
              We strictly follow the GDPR user data and privacy guidelines.
            </p>
            <br />

            <div class="text-right inline-items content-accept-warning">
              <p class="h5 text-white explanation-text">
                Thank you! We’re so glad you're here...
              </p>
              <SButtonMaterial
                class="col-1 mb-0 accept-warning"
                buttonType="button"
                color="danger"
                textColor="white"
                materialClass="dense"
                text="OK"
                data-cy="loginPageButton"
                @button="checkWarning"
              />
            </div>
          </div>
        </div>
      </div>
    </md-content>
  </div>
</template>

<script>
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
export default {
  name: "SafariWarning",
  components: {
    SButtonMaterial,
  },
  data() {
    return {
      showWarning: false,
    };
  },
  methods: {
    checkWarning() {
      this.$emit("safari-warning", true);
      this.hide();
    },
    show() {
      this.showWarning = true;
    },
    hide() {
      this.showWarning = false;
    }
  },
  computed: {
    showSafariWarning() {
      return this.showWarning;
    }
  }
};
</script>

<style lang="scss" scoped>
.bg-custom {
  background-color: $secondary;
}
.button-fixed {
  bottom: 0;
  position: fixed;
  right: 0;
  border-radius: 10px;
  z-index: 20 !important;
  padding: 0;
}
.fas {
  cursor: pointer;
  font-size: 24px;
}
.warning-title {
  font-weight: bold;
  font-size: 20px;
  line-height: 20px;
  letter-spacing: 1.25px;
  color: $white !important;
  text-transform: uppercase;
}
.explanation-text {
  margin-top: 0.7rem;
  line-height: 16px;
  letter-spacing: 1.25px;
  font-weight: normal;
}
.accept-warning {
  height: 40px !important;
  font-size: 14px !important;
}
.content-accept-warning {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.gpdr-text {
  font-weight: bold;
}
.row-column {
  flex-direction: column;
  padding: 0rem 1rem 0 1rem;
}
.hide-warning {
  display: none;
}
</style>
